<template>
    <div>
        <menu-bar v-if="$auth.ready() && loaded && $auth.check()" active="home"></menu-bar>
        <login v-if="$auth.ready() && loaded && !$auth.check()"></login>
        <div v-if="$auth.ready() && loaded && $auth.check()" class="large-8 columns content__column"><messages></messages></div>
    </div>
</template>

<script>
import Login from './Login.vue';
import MenuBar from './Menu.vue';
import Messages from './Messages.vue';

export default {
    data() {
        return {
            loaded: false,
        };
    },
    components: {
        Login,
        MenuBar,
        Messages,
    },
    mounted() {
        var _this = this;
        _this.loaded = true;
    },
    created() {
        var _this = this;
        this.$auth.ready(function() {});
    },
};
</script>



// WEBPACK FOOTER //
// src/components/Home.vue